import { useFormikContext } from 'formik';
import { useDictionaryValues } from 'services/api/queries';
import { EPD_DICTIONARY_CODES } from 'services/api/constants';
import { CountryModel, CurrencySelectModel } from 'services/EpdClient';
import { useTranslation } from 'react-i18next';
import calculateCurrencyOptions from './calculateCurrencyOptions';
import { StyledReactSelect } from 'styles/Styles.styled';
import { Option } from 'types/types';
import { DropdownIndicator } from 'components/form/DropdownIndicator';

interface AvailableCountryCurrenciesProps {
  countries: CountryModel[];
  styles: any;
  tooltip?: string | undefined;
  enableTooltipError?: boolean | undefined;
  supressErrors?: boolean | undefined;
  isRequired: boolean;
  isDisabled?: boolean;
}

const AvailableCountryCurrencies: React.FC<AvailableCountryCurrenciesProps> = ({
  countries,
  styles,
  tooltip,
  enableTooltipError,
  supressErrors,
  isRequired,
  isDisabled,
}) => {
  const { values: formValues } = useFormikContext<CurrencySelectModel>();
  const eurCurrencyCountries = useDictionaryValues(EPD_DICTIONARY_CODES.EUR_CURRENCY_COUNTRIES);
  const { t } = useTranslation();
  const currencyOptions = (() => {
    const countryId = formValues.invoiceCountryOption?.value;
    if (!countryId || !eurCurrencyCountries.data) return [];
    const countryAplha2Code = countries.find((c) => c.id === countryId)?.alpha2Code;
    if (!countryAplha2Code) return [];
    return calculateCurrencyOptions(
      countryAplha2Code,
      eurCurrencyCountries.data.map((c) => c.value)
    ) as Option[];
  })();

  return (
    <StyledReactSelect
      required={isRequired}
      label={t('invoicePreferredCurrency')}
      name="preferredCurrencyOption"
      tooltip={tooltip}
      isDisabled={currencyOptions.length === 1 || isDisabled}
      placeholder={t('placeholder.select')}
      styles={styles}
      options={currencyOptions}
      enableTooltipError={enableTooltipError}
      supressErrors={supressErrors}
      components={{ DropdownIndicator }}
    />
  );
};

export default AvailableCountryCurrencies;
